import {createAsyncThunk, createSlice} from '@reduxjs/toolkit'
import {
  onGetCompanyStatistic,
  onGetJobStatistic,
  onGetPagedAllCompanies,
  onGetPagedAllFeaturedNews,
  onGetPagedAllNews,
} from '../../../app/pages/dashboard/core/_requests'
import {onGetPagedAllJobs} from '../../../app/pages/dashboard/core/_requests'
import {onGetPagedAllJobsForGraduates} from '../../../app/pages/dashboard/core/_requests'
interface DashboardState {
  dashboardNews: any
  dashboardJobs: any
  dashboardJobConfirmations: any
  dashboardCompanyConfirmations: any
  isLoading: boolean
  isFWLoading: boolean
  isNWLoading: boolean
  isJPLoading: boolean
}
const initialState = {
  dashboardNews: [],
  dashboardFeaturedNews: [],
  dashboardJobs: [],
  dashboardJobConfirmations: [],
  dashboardCompanyConfirmations: [],
  companyStatistic : [],
  jobStatistic : [],
  isLoading: true,
  isFWLoading: true,
  isNWLoading: true,
  isJPLoading: true,
} as DashboardState

export const fetchDashboardNews = createAsyncThunk('dashboard/fetchDashboardNews', async () => {
  const data: any = await onGetPagedAllNews({
    maxResultCount: 5,
    skipCount: 0,
    keyword: '',
    isActive : true,
    isFeatured : false 
  })
  return data.data.result.items
})

export const fetchFeaturedDashboardNews = createAsyncThunk('dashboard/fetchFeaturedDashboardNews', async () => {
  const data: any = await onGetPagedAllFeaturedNews({
    maxResultCount: 5,
    skipCount: 0,
    keyword: '',
    isActive : true
  })
  return data.data.result.items
})

export const fetchDashboardJobs = createAsyncThunk('dashboard/fetchDashboardJobs', async () => {
  const data: any = await onGetPagedAllJobs({
    maxResultCount: 5,
    skipCount: 0,
    keyword: '',
  })
  return data.data.result.items
})

export const fetchDashboardJobConfirmations = createAsyncThunk(
  'dashboard/fetchDashboardJobConfirmations',
  async () => {
    const data: any = await onGetPagedAllJobsForGraduates({
      maxResultCount: 5,
      skipCount: 0,
      keyword: '',
    })
    return data.data.result
  }
)
export const fetchDashboardJobStatistic = createAsyncThunk(
  'dashboard/fetchDashboardJobStatistic',
  async () => {
    const data: any = await onGetJobStatistic()
    return data.data.result
  }
)
export const fetchDashboardCompanyStatistic = createAsyncThunk(
  'dashboard/fetchDashboardCompanyStatistic',
  async () => {
    const data: any = await onGetCompanyStatistic()
    return data.data.result
  }
)

export const fetchDashboardCompanyConfirmations = createAsyncThunk(
  'dashboard/fetchDashboardCompanyConfirmations',
  async () => {
    const data: any = await onGetPagedAllCompanies({
      maxResultCount: 5,
      skipCount: 0,
      keyword: '',
    })
    return data.data.result
  }
)

const dashboardSlice = createSlice({
  name: 'dashboard',
  initialState,
  reducers: {
    activateLoading: (state) => {
      state.isLoading = true
      state.isFWLoading = true
      state.isNWLoading = true
      state.isJPLoading = true
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchDashboardNews.pending, (state: any) => {
      state.isNWLoading = true
    })
    builder.addCase(fetchDashboardNews.fulfilled, (state: any, action) => {
      state.dashboardNews = action.payload
      state.isNWLoading = false
    })
    builder.addCase(fetchDashboardNews.rejected, (state: any) => {
      state.isNWLoading = false
    })  
     builder.addCase(fetchFeaturedDashboardNews.pending, (state: any) => {
      state.isFWLoading = true
    })
    builder.addCase(fetchFeaturedDashboardNews.fulfilled, (state: any, action) => {
      state.dashboardFeaturedNews = action.payload
      state.isFWLoading = false
    })
    builder.addCase(fetchFeaturedDashboardNews.rejected, (state: any) => {
      state.isFWLoading = false
    })
    //
    builder.addCase(fetchDashboardJobs.pending, (state: any) => {
      state.isJPLoading = true
    })
    builder.addCase(fetchDashboardJobs.fulfilled, (state: any, action) => {
      state.dashboardJobs = action.payload
      state.isJPLoading = false
    })
    builder.addCase(fetchDashboardJobs.rejected, (state: any) => {
      state.isJPLoading = false
    })
    //
    builder.addCase(fetchDashboardJobConfirmations.pending, (state: any) => {
      state.isLoading = true
    })
    builder.addCase(fetchDashboardJobConfirmations.fulfilled, (state: any, action) => {
      state.dashboardJobConfirmations = action.payload
      state.isLoading = false
    })
    builder.addCase(fetchDashboardJobConfirmations.rejected, (state: any) => {
      state.isLoading = false
    })
    //
    builder.addCase(fetchDashboardCompanyConfirmations.pending, (state: any) => {
      state.isLoading = true
    })
    builder.addCase(fetchDashboardCompanyConfirmations.fulfilled, (state: any, action) => {
      state.dashboardCompanyConfirmations = action.payload
      state.isLoading = false
    })
    builder.addCase(fetchDashboardCompanyConfirmations.rejected, (state: any) => {
      state.isLoading = false
    })
    //
    builder.addCase(fetchDashboardCompanyStatistic.pending, (state: any) => {
      state.isLoading = true
    })
    builder.addCase(fetchDashboardCompanyStatistic.fulfilled, (state: any, action) => {
      state.companyStatistic = action.payload
      state.isLoading = false
    })
    builder.addCase(fetchDashboardCompanyStatistic.rejected, (state: any) => {
      state.isLoading = false
    })
    //
    builder.addCase(fetchDashboardJobStatistic.pending, (state: any) => {
      state.isLoading = true
    })
    builder.addCase(fetchDashboardJobStatistic.fulfilled, (state: any, action) => {
      state.jobStatistic = action.payload
      state.isLoading = false
    })
    builder.addCase(fetchDashboardJobStatistic.rejected, (state: any) => {
      state.isLoading = false
    })
  },
})

export const {activateLoading} = dashboardSlice.actions

export default dashboardSlice.reducer
